const TermsOfServicePage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6" data-aos="slide-right">
              Terms of Service
            </h1>
            <p className="text-xl text-gray-100" data-aos="slide-left" data-aos-delay="100">
              Last updated: December 15, 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <div className="space-y-8 text-gray-700">
              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  1. Acceptance of Terms
                </h2>
                <p className="leading-relaxed">
                  By accessing and using Kommonview's services, you accept and agree to be bound by the terms
                  and provision of this agreement. If you do not agree to these terms, please do not use our
                  services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  2. Services Description
                </h2>
                <p className="leading-relaxed mb-4">
                  Kommonview is a cloud-first technology company that designs, builds, and operates modern
                  digital infrastructure at scale. Our services include but are not limited to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>IT Infrastructure Services (Hardware, Software, Server & Client Compute Support)</li>
                  <li>Public Cloud & SaaS Platforms (AWS, Azure, GCP)</li>
                  <li>Atlassian Cloud Services (Jira, Confluence, Opsgenie)</li>
                  <li>DevOps & Automation (CI/CD, Infrastructure as Code)</li>
                  <li>Bespoke Software Solutions</li>
                  <li>Digital Advertising Solutions</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  3. User Responsibilities
                </h2>
                <p className="leading-relaxed mb-4">
                  As a user of our services, you agree to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Maintain the security of your account credentials</li>
                  <li>Use our services in compliance with all applicable laws</li>
                  <li>Not engage in any activities that could harm our systems or other users</li>
                  <li>Respect intellectual property rights</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  4. Payment Terms
                </h2>
                <p className="leading-relaxed">
                  Payment terms will be specified in individual project agreements. Generally:
                </p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Invoices are due within 30 days of issuance</li>
                  <li>Late payments may incur additional fees</li>
                  <li>All prices are in USD unless otherwise specified</li>
                  <li>Refunds are subject to our refund policy</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  5. Intellectual Property
                </h2>
                <p className="leading-relaxed">
                  Upon full payment, clients receive ownership of custom work created specifically for their
                  project. Kommonview retains rights to:
                </p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Reusable code components and frameworks</li>
                  <li>General methodologies and processes</li>
                  <li>Portfolio rights to showcase completed work</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  6. Warranties and Disclaimers
                </h2>
                <p className="leading-relaxed">
                  Our services are provided "as is" without warranties of any kind, either express or implied.
                  We do not guarantee that our services will be uninterrupted, error-free, or completely secure.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  7. Limitation of Liability
                </h2>
                <p className="leading-relaxed">
                  Kommonview shall not be liable for any indirect, incidental, special, consequential, or
                  punitive damages resulting from your use or inability to use our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  8. Termination
                </h2>
                <p className="leading-relaxed">
                  We reserve the right to terminate or suspend services at our discretion, with or without
                  notice, for conduct that we believe violates these terms or is harmful to other users or our
                  business.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  9. Modifications to Terms
                </h2>
                <p className="leading-relaxed">
                  We reserve the right to modify these terms at any time. Changes will be effective immediately
                  upon posting to our website. Continued use of our services after changes constitutes acceptance
                  of the modified terms.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  10. Governing Law
                </h2>
                <p className="leading-relaxed">
                  These terms shall be governed by and construed in accordance with the laws of the jurisdiction
                  in which Kommonview operates, without regard to its conflict of law provisions.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                  11. Contact Information
                </h2>
                <p className="leading-relaxed">
                  For questions about these Terms of Service, please contact us at:
                </p>
                <p className="mt-4">
                  <strong>Email:</strong> <a href="mailto:legal@kommonview.com" className="text-primary hover:text-secondary">legal@kommonview.com</a><br />
                  <strong>Support Portal:</strong> <a href="https://kommonview.atlassian.net/servicedesk/customer/portal/1" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-secondary">kommonview.atlassian.net/servicedesk</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfServicePage;
